import { render, staticRenderFns } from "./Bookmark.vue?vue&type=template&id=6770b0d0&"
import script from "@/scripts/Bookmark/index.js?vue&type=script&lang=js&"
export * from "@/scripts/Bookmark/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports